<template>
    <transition name="fade">

        <div id="overlay" v-if="v" class="hidden-xs">

            <div  class="overlay-content" onclick="event.stopPropagation();">
                <div class="age-content text-center">
                    <img src="images/bignewlogo.png" alt="" width="150" style="margin-bottom:10px;">

                    <h4>A Bora Ital-nagykereskedelmi Kft. elkötelezett a kulturált italfogyasztás iránt.<br />
                        Szeszesital fogyasztását 18 év alatt nem ajánljuk. </h4>
                        <h3>Kérjük, adja meg életkorát!</h3>
                        <div class="row" style="margin-top:20px;">
                            <div class="col-sm-6">
                                <button class="age-button" @click="accept">Elmúltam 18 éves, belépek</button>
                            </div>
                            <div class="col-sm-6">
                                <button class="age-button" @click="decline">Oldal elhagyása</button>
                            </div>
                        </div>
                </div>
    		</div>
            <!--</div>-->
        </div>
    </transition>

</template>

<script>
export default{
    props:['images'],
    data:function () {
        return {
            v:false,
        };
    },
    mounted:function () {
        var self = this;
    },
    methods:{
        show(){
            this.v = true;
        },
        accept(){
            console.log('accept');
            this.v = false;
            localStorage.ageVerified = true;
        },
        decline(){
            window.location = "https://google.com"
        }
    }
}
</script>

<style>
    #overlay {
        position: fixed; /* Sit on top of the page content */
        display: block;
        width: 100%; /* Full width (cover the whole page) */
        height: 100%; /* Full height (cover the whole page) */
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        background-color: rgba(0, 0, 0, 0.8); /* Black background with opacity */
        z-index: 999999; /* Specify a stack order in case you're using a different order for other elements */
        cursor: pointer; /* Add a pointer on hover */
    }

    .overlay-content {
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        -ms-transform: translate(-50%, -50%);
    }
    .fade-enter-active, .fade-leave-active {
        transition: opacity .5s
    }
    .fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
        opacity: 0
    }
    .age-content{
        padding: 30px;
        max-with:350px;
        max-height:300px;
        background-color: white;
    }
    .age-button{
        background: #8c2c1e;
        color:white;
        border-width: 0px;
        font-size: 18px;
        padding: 5px 10px;
    }
</style>



// WEBPACK FOOTER //
// AgeVerification.vue?383e55ac